import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import {
  Modal,
  Breadcrumb,
  Icon,
  Label,
  Loader,
  Checkbox,
  Popup,
  List,
  Table,
} from 'semantic-ui-react';
import $ from 'jquery';
import cx from 'classnames';
import { v4 as uuidv4 } from 'uuid';
import { observer, inject } from 'mobx-react';
import WithRouter from '../Extensions/WithRouter';
import api from '../../api';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import filterIcon from '../../images/components/contnets_header/filter icon.png';
import searchIcon from '../../images/common/search_icon.png';

class LeakageListModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMLK: props.isOpenMLK,
      uploadedFileId: props.uploadedFileId,
      fileName: props.fileName,
      isLoading: false,
      isMenuVisible: false,
      searchKeyword: '',
      filters: '',
      checkValue: [],
      leakageList: [],
      popupStatus: null,
      isErrorWithSearch: false,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.ui.list .item .list.leak_popup', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });

    $(document).on('mouseover', '.ui.table .leak_row', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps) {
    const { isOpenMLK, uploadedFileId, fileName } = this.props;
    if (prevProps.isOpenMLK !== isOpenMLK) {
      this.setState({
        isOpenMLK,
        uploadedFileId,
        fileName,
        filters: '',
        searchKeyword: '',
        checkValue: [],
        popupStatus: null,
        isErrorWithSearch: false,
        isMenuVisible: false,
      }, () => {
        if (isOpenMLK) {
          this.getLeakageList();
        }
      });
      this.setState(this.props);
    }
  }

  handlePopupOpen = (value) => {
    this.setState({
      popupStatus: value,
    });
  };

  handlePopupClose = () => {
    this.setState({
      popupStatus: null,
    });
  };

  handleSearch(event) {
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            isErrorWithSearch: true,
          },
          () => {
            setTimeout(() => {
              this.setState({
                isErrorWithSearch: false,
              });
            }, 1500);
          }
        );
        return;
      }
      this.setState({
        searchKeyword: event.target.value,
        leakageList: [],
      }, () => {
        this.getLeakageList();
      });
    }
  }

  handleCheckChange(e, { value }) {
    const { checkValue } = this.state;
    let newState;
    if (checkValue.indexOf(value) > -1) {
      newState = checkValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValue, value];
    }
    this.setState({
      checkValue: newState,
    });
  }

  getLeakageList = () => {
    const { uploadedFileId, searchKeyword, filters } = this.state;
    const obj = {
      search: searchKeyword,
      filter: filters,
    };

    this.setState({
      isLoading: true,
    }, () => {
      api
        .getLeakageList(uploadedFileId, obj)
        .then((response) => {
          const data = response.response;
          this.setState({
            isLoading: false,
            leakageList: data,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  };

  onSubmit = () => {
    const { checkValue } = this.state;
    let filterData;
    let i = 0;
    if (checkValue.length !== 0) {
      for (i; i < checkValue.length; i++) {
        if (i === 0) {
          filterData = checkValue[i];
        } else {
          filterData = `${filterData},${checkValue[i]}`;
        }
      }
    } else {
      filterData = '';
    }

    this.setState({
      filters: filterData,
      isMenuVisible: false,
    }, () => {
      this.getLeakageList();
    });
  };

  closeMenu = () => {
    this.setState({
      isMenuVisible: false,
    });
  };

  toggleMenu() {
    const { isMenuVisible } = this.state;
    this.setState({
      isMenuVisible: !isMenuVisible,
    });
  }

  clearSearch() {
    this.search.value = '';
    this.setState(
      {
        searchKeyword: '',
        leakageList: [],
      },
      () => {
        this.getLeakageList();
      }
    );
  }

  closeModal(e) {
    const { closeModal } = this.props;
    if (e.target.tagName === 'TD' || e.target.tagName === 'SPAN') {
      return;
    }
    this.setState({
      isOpenMLK: false,
      leakageList: [],
    });
    closeModal();
  }

  renderList = (data, i) => {
    const { popupStatus } = this.state;
    const { translate } = this.props;

    return (
      <Table
        key={data.name}
        celled
        structured
        fixed
        //singleLine
      >
        <Table.Body>
          {
            data.leakages.map((entity, index) => {
              return (
                <Table.Row key={uuidv4()}>
                  {
                    index === 0 ? (
                      <Table.Cell
                        selectable
                        rowSpan={data.leakages.length}
                        className="linked"
                        style={{ width: '20%' }}
                        title={[data.name].join('')}
                      >
                        <Popup
                          trigger={
                            <span>{data.name}</span>
                          }
                          on="click"
                          position="bottom left"
                          open={
                            popupStatus === `${data.name}_${i}`
                          }
                          onOpen={() => {
                            return this.handlePopupOpen(`${data.name}_${i}`);
                          }}
                          onClose={this.handlePopupClose}
                        >
                          <List>
                            <List.Item>
                              <List.List className="leak_popup">
                                <span>
                                  {translate('modal.leakage_info.scanned_file')}
                                </span>
                                {data.name}
                              </List.List>
                              <List.List className="leak_popup">
                                <span>
                                  {translate('modal.leakage_info.parent_name')}
                                </span>
                                {data.parent_name}
                              </List.List>
                              <List.List className="leak_popup">
                                <span>
                                  {translate('modal.leakage_info.path')}
                                </span>
                                {data.path}
                              </List.List>
                              <List.List className="leak_popup">
                                <span>
                                  {translate('modal.leakage_info.sha256')}
                                </span>
                                {data.checksum}
                              </List.List>
                            </List.Item>
                          </List>
                        </Popup>
                      </Table.Cell>
                    ) : null
                  }
                  <Table.Cell
                    style={{ width: '25%' }}
                    title={[entity.type].join('')}
                  >
                    {entity.type}
                  </Table.Cell>
                  {
                    Array.isArray(entity.leakage) ? (
                      <Table.Cell
                        style={{ width: '40%' }}
                        //title={[entity.leakage].join('')}
                      >
                        {
                          entity.leakage.map((lk, idx) => {
                            if (idx === 0) {
                              return (
                                <div className="leak_row" key={uuidv4()}>
                                  {lk}
                                  {' '}
                                  <br />
                                </div>
                              );
                            }
                            return (
                              <div className="leak_row" key={uuidv4()} style={{ marginTop: '1px' }}>
                                {lk}
                                {' '}
                                <br />
                              </div>
                            );
                          })
                        }
                      </Table.Cell>
                    ) : (
                      <Table.Cell
                        style={{ width: '40%' }}
                        title={[entity.leakage].join('')}
                      >
                        {entity.leakage}
                      </Table.Cell>
                    )
                  }
                  <Table.Cell
                    selectable
                    className="linked"
                    style={{ width: '15%' }}
                  >
                    {
                      Object.keys(entity.data).map((objKey, k) => {
                        if (k === 0) {
                          return (
                            <Popup
                              trigger={(
                                <span key={uuidv4()}>
                                  {objKey}
                                  <br />
                                </span>
                              )}
                              key={uuidv4()}
                              on="click"
                              position="bottom left"
                              open={
                                popupStatus === `${data.name}_${entity.type}_${i}_${index}_${k}`
                              }
                              onOpen={() => {
                                return this.handlePopupOpen(`${data.name}_${entity.type}_${i}_${index}_${k}`);
                              }}
                              onClose={this.handlePopupClose}
                            >
                              <List>
                                <List.Item>
                                  <List.Header>
                                    {
                                      objKey === 'identifiers'
                                        && translate('modal.leakage_info.identifiers')
                                    }
                                    {
                                      objKey === 'files'
                                        && translate('modal.leakage_info.files')
                                    }
                                  </List.Header>
                                  {
                                    objKey === 'identifiers'
                                          && entity.data.identifiers.map((nest) => {
                                            return (
                                              <List.List className="leak_popup" key={uuidv4()}>{nest}</List.List>
                                            );
                                          })
                                  }
                                  {
                                    objKey === 'files'
                                          && entity.data.files.map((nest) => {
                                            return (
                                              <List.List className="leak_popup" key={uuidv4()}>{nest}</List.List>
                                            );
                                          })
                                  }
                                </List.Item>
                              </List>
                            </Popup>
                          );
                        }
                        return (
                          <Popup
                            trigger={(
                              <span key={uuidv4()} style={{ marginTop: '1px' }}>
                                {objKey}
                                <br />
                              </span>
                            )}
                            key={uuidv4()}
                            on="click"
                            position="bottom left"
                            open={
                              popupStatus === `${data.name}_${entity.type}_${i}_${index}_${k}`
                            }
                            onOpen={() => {
                              return this.handlePopupOpen(`${data.name}_${entity.type}_${i}_${index}_${k}`);
                            }}
                            onClose={this.handlePopupClose}
                          >
                            <List>
                              <List.Item>
                                <List.Header>
                                  {
                                    objKey === 'identifiers'
                                      && translate('modal.leakage_info.identifiers')
                                  }
                                  {
                                    objKey === 'files'
                                      && translate('modal.leakage_info.files')
                                  }
                                </List.Header>
                                {
                                  objKey === 'identifiers'
                                        && entity.data.identifiers.map((nest) => {
                                          return (
                                            <List.List className="leak_popup" key={uuidv4()}>{nest}</List.List>
                                          );
                                        })
                                }
                                {
                                  objKey === 'files'
                                        && entity.data.files.map((nest) => {
                                          return (
                                            <List.List className="leak_popup" key={uuidv4()}>{nest}</List.List>
                                          );
                                        })
                                }
                              </List.Item>
                            </List>
                          </Popup>
                        );
                      })
                    }
                  </Table.Cell>
                </Table.Row>
              );
            })
          }
        </Table.Body>
      </Table>
    );
  };

  render() {
    const {
      isErrorWithSearch,
      isLoading,
      isMenuVisible,
      checkValue,
      leakageList,
      isOpenMLK,
      fileName,
    } = this.state;
    const { translate } = this.props;

    return (
      <Modal open={isOpenMLK} onClose={this.closeModal}>
        <div
          className="more_info_popup leakage"
          style={{ borderRadius: '20px' }}
        >
          <div className="popup_header ">
            <h4 className="popup_name">
              <Icon name="shield" />
              <Breadcrumb>
                <Breadcrumb.Section>{translate('modal.leakage_info.leakage_list')}</Breadcrumb.Section>
                <Breadcrumb.Divider>/</Breadcrumb.Divider>
                <Breadcrumb.Section>
                  <span>{fileName}</span>
                </Breadcrumb.Section>
              </Breadcrumb>
            </h4>
            <a
              className="close_button"
              style={{ cursor: 'pointer' }}
              onClick={this.closeModal}
              onKeyUp={this.closeModal}
            >
              <img src={closeBtn} alt="" />
            </a>
          </div>
          <div className="util_wrap">
            <div className="util_item">
              <div className="search_box">
                <span className="search_icon">
                  <img src={searchIcon} alt="" />
                </span>
                <input
                  className="text"
                  placeholder="Search Leakages..."
                  ref={(ref) => { this.search = ref; }}
                  onKeyPress={this.handleSearch}
                />
                <a
                  className="reset_icon"
                  onClick={this.clearSearch}
                  onKeyUp={this.clearSearch}
                >
                  x

                </a>
                {isErrorWithSearch && <Label basic color="red" pointing>{translate('contents_header.message.least_two_required_to_search')}</Label>}
              </div>
            </div>
            <div className="util_item">
              <div
                className="util_item common_filter_toggle_button"
              >
                <a
                  className="util_button icon_button"
                  onClick={this.toggleMenu}
                  onKeyUp={this.toggleMenu}
                >
                  <img src={filterIcon} alt="" />
                </a>
                <div
                  className={cx('common_filter', {
                    hide: !isMenuVisible,
                  })}
                >
                  <div className="common_filter_header">
                    <h2>{translate('contents_header.menu.filter_by')}</h2>
                  </div>
                  <div className="common_filter_contents">
                    <div className="common_filter_contents_inner">
                      <div className="common_filter_item">
                        <div className="checkbox_wrap">
                          <ul>
                            <li>
                              <Checkbox
                                label={translate('modal.leakage_info.telephone')}
                                value="leakage_tp"
                                checked={checkValue.indexOf('leakage_tp') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                            <li>
                              <Checkbox
                                label={translate('modal.leakage_info.email')}
                                value="leakage_em"
                                checked={checkValue.indexOf('leakage_em') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                            <li>
                              <Checkbox
                                label={translate('modal.leakage_info.ipv4')}
                                value="leakage_i4"
                                checked={checkValue.indexOf('leakage_i4') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                            <li>
                              <Checkbox
                                label={translate('modal.leakage_info.ipv6')}
                                value="leakage_i6"
                                checked={checkValue.indexOf('leakage_i6') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                            <li>
                              <Checkbox
                                label={translate('modal.leakage_info.url')}
                                value="leakage_ur"
                                checked={checkValue.indexOf('leakage_ur') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                            <li>
                              <Checkbox
                                label={translate('modal.leakage_info.password')}
                                value="leakage_ps"
                                checked={checkValue.indexOf('leakage_ps') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                            <li>
                              <Checkbox
                                label={translate('modal.leakage_info.key_info')}
                                value="leakage_ky"
                                checked={checkValue.indexOf('leakage_ky') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="common_filter_footer">
                    <a
                      className="cancel_button"
                      onClick={this.closeMenu}
                      onKeyUp={this.closeMenu}
                    >
                      {translate('modal.button.cancel')}
                    </a>
                    <a
                      className="apply_button"
                      onClick={this.onSubmit}
                      onKeyUp={this.onSubmit}
                    >
                      {translate('modal.button.apply')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Scrollbars
            renderTrackHorizontal={() => {
              return <div />;
            }}
            renderThumbHorizontal={() => {
              return <div />;
            }}
            style={{
              height: '360px',
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            <div className="popup_contents">
              {
                isLoading ? (
                  <div className="popup_content_wrap">
                    <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '30%' }}>
                      <Loader
                        active={isLoading}
                        inline="centered"
                        size="medium"
                      />
                    </div>
                  </div>
                ) : (
                  <div className="popup_content_wrap">
                    <Table
                      celled
                      structured
                      fixed
                    >
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell style={{ width: '20%' }}>{translate('modal.leakage_info.scanned_file')}</Table.HeaderCell>
                          <Table.HeaderCell style={{ width: '25%' }}>{translate('modal.leakage_info.type')}</Table.HeaderCell>
                          <Table.HeaderCell style={{ width: '40%' }}>{translate('modal.leakage_info.leakage')}</Table.HeaderCell>
                          <Table.HeaderCell style={{ width: '15%' }}>{translate('modal.leakage_info.data')}</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {
                          leakageList.map((item, index) => {
                            return (
                              <Table.Row key={item.name}>
                                <Table.Cell colSpan={4} style={{ padding: '0 0 0 0' }}>
                                  <div>
                                    {this.renderList(item, index)}
                                  </div>
                                </Table.Cell>
                              </Table.Row>
                            );
                          })
                        }
                      </Table.Body>
                    </Table>
                  </div>
                )
              }
            </div>
          </Scrollbars>
        </div>
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(LeakageListModal)));
